module.exports = BMap;


//////////////////
// WEBPACK FOOTER
// external "BMap"
// module id = 1371
// module chunks = 